<div class="header-bar">
  <h1>Checklist Fees</h1>
</div>

<div class="content-container">
  <p-table
    #cf
    [value]="checklists"
    [paginator]="true"
    (onEditComplete)="onEditComplete($event)"
    [rows]="25"
    [totalRecords]="totalRecords"
    [responsive]="true"
    resizableColumns="true"
    class="fixed-table"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="customerName">Customer</th>
        <th pSortableColumn="checklistName">Name</th>
        <th pSortableColumn="feeFromCustomer">FeeFromCustomer</th>
        <th pSortableColumn="feeToSupplier">FeeToSupplier</th>
      </tr>
      <tr class="filter-row">
        <th>
          <input
            pInputText
            type="text"
            (input)="cf.filter($event.target.value, 'customerName', 'contains')"
            placeholder="Filter"
            class="ui-column-filter"
          />
        </th>
        <th>
          <input
            pInputText
            type="text"
            (input)="cf.filter($event.target.value, 'checklistName', 'contains')"
            placeholder="Filter"
            class="ui-column-filter"
          />
        </th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td>{{ item.customerName }}</td>
        <td>{{ item.checklistName }}</td>
        <td [pEditableColumnField]="'feeFromCustomer'" [pEditableColumn]="item" class="text-center">
          <p-cellEditor [style]="{ width: '100px' }">
            <ng-template pTemplate="input">
              &pound;&nbsp;<input
                type="text"
                [(ngModel)]="item.feeFromCustomer"
                pInputText
                class="price-input"
              />
            </ng-template>
            <ng-template pTemplate="output">
              &pound;&nbsp;<input
                type="text"
                [(ngModel)]="item.feeFromCustomer"
                pInputText
                class="price-input"
              />
            </ng-template>
          </p-cellEditor>
        </td>
        <td [pEditableColumnField]="'feeToSupplier'" [pEditableColumn]="item" class="text-center">
          <p-cellEditor>
            <ng-template pTemplate="input">
              &pound;&nbsp;<input
                type="text"
                [(ngModel)]="item.feeToSupplier"
                pInputText
                class="price-input"
              />
            </ng-template>
            <ng-template pTemplate="output">
              &pound;&nbsp;<input
                type="text"
                [(ngModel)]="item.feeToSupplier"
                pInputText
                class="price-input"
              />
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
